module.exports = "<div class=field-container><input autocomplete=off ng-readonly=true placeholder={{::myPlaceholder}} class=\"select-input {{::inputClass}}\" value=\"{{ value }}\" ng-blur=onFocusLost() name=select id=\"{{inputId ? inputId : 'select'}}\" ng-click=\"showResults = true\"><label class=\"select-label {{::labelClass}}\" ng-class=\"{'stay-up': model}\" for=\"{{inputId ? inputId : 'select'}}\">{{::labelText}}</label><span class=triangle-down></span></div><div ng-transclude ng-click=clickHandler() class=autocomplete-results ng-show=showResults></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./client/components/discount-field/discount-field.html
 ** module id = 147
 ** module chunks = 0
 **/